import {createSlice} from "@reduxjs/toolkit";

const planSection = createSlice({
  name: "planSection",
  initialState: {
    planType: null,
  },
  reducers: {
    setPlanType: (state, action) => {
      state.planType = action.payload;
    },
  },
});

export const {setPlanType} = planSection.actions;
export default planSection.reducer;
